import { ArrowLeft, Phone, Mail, MessageCircle, ChevronDown, ChevronUp, Package, List, TrendingUp, User } from "lucide-react";
import { motion } from "framer-motion";
import { useCourierLanguage } from "../contexts/CourierLanguageContext";
import { useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CourierHelp({
  navigateTo
}) {
  const {
    t
  } = useCourierLanguage();
  const [expandedFaq, setExpandedFaq] = useState(null);
  const toggleFaq = index => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };
  const faqItems = [{
    question: t.faqStartRoute,
    answer: t.faqStartRouteAnswer
  }, {
    question: t.faqContactCustomer,
    answer: t.faqContactCustomerAnswer
  }, {
    question: t.faqDeliveryFails,
    answer: t.faqDeliveryFailsAnswer
  }, {
    question: t.faqChangeLanguage,
    answer: t.faqChangeLanguageAnswer
  }, {
    question: t.faqUpdateProfile,
    answer: t.faqUpdateProfileAnswer
  }];
  const contactMethods = [{
    icon: Phone,
    label: t.phoneSupport,
    value: "+994 12 555 0000",
    action: () => window.open("tel:+994125550000"),
    color: "#2D58AD"
  }, {
    icon: Mail,
    label: t.emailSupport,
    value: "support@smartcargo.solutions",
    action: () => window.open("mailto:support@smartcargo.az"),
    color: "#10B981"
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: "min-h-screen bg---F5F6FA- pb-24",
    children: [/*#__PURE__*/_jsx("div", {
      className: "bg-gradient-to-r from---2D58AD- to---71A4F4- text-white p-4 pb-6",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-4",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: () => navigateTo("profile"),
          className: "w-10 h-10 bg-white-20 backdrop-blur-sm rounded-xl flex items-center justify-center hover-bg-white-30 transition-colors",
          children: /*#__PURE__*/_jsx(ArrowLeft, {
            className: "w-6 h-6"
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h1", {
            className: "text-2xl font-bold",
            children: t.help
          }), /*#__PURE__*/_jsx("p", {
            className: "text-white-80 text-sm",
            children: t.helpSubtitle
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "px-4 neg-mt-2",
      children: [/*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-6",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "font-bold text---000080- mb-4",
          children: t.contactSupport
        }), /*#__PURE__*/_jsx("div", {
          className: "space-y-3",
          children: contactMethods.map((method, index) => /*#__PURE__*/_jsxs("button", {
            onClick: method.action,
            className: "w-full flex items-center gap-4 p-4 bg---F5F6FA- rounded-xl hover-bg---DEEAFC- transition-colors",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-12 h-12 rounded-xl flex items-center justify-center",
              style: {
                backgroundColor: `${method.color}20`
              },
              children: /*#__PURE__*/_jsx(method.icon, {
                className: "w-6 h-6",
                style: {
                  color: method.color
                }
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex-1 text-left",
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-sm text-neg-708094-",
                children: method.label
              }), /*#__PURE__*/_jsx("p", {
                className: "font-semibold text---000080-",
                children: method.value
              })]
            })]
          }, index))
        })]
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.1
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-6",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "font-bold text---000080- mb-4",
          children: t.frequentlyAskedQuestions
        }), /*#__PURE__*/_jsx("div", {
          className: "space-y-3",
          children: faqItems.map((faq, index) => /*#__PURE__*/_jsxs("div", {
            className: "border-b border-gray-100 last-border-0 pb-3 last-pb-0",
            children: [/*#__PURE__*/_jsxs("button", {
              onClick: () => toggleFaq(index),
              className: "w-full flex items-center justify-between text-left py-2",
              children: [/*#__PURE__*/_jsx("span", {
                className: "font-semibold text---000080- pr-4",
                children: faq.question
              }), expandedFaq === index ? /*#__PURE__*/_jsx(ChevronUp, {
                className: "w-5 h-5 text-neg-708094- flex-shrink-0"
              }) : /*#__PURE__*/_jsx(ChevronDown, {
                className: "w-5 h-5 text-neg-708094- flex-shrink-0"
              })]
            }), expandedFaq === index && /*#__PURE__*/_jsx(motion.div, {
              initial: {
                opacity: 0,
                height: 0
              },
              animate: {
                opacity: 1,
                height: "auto"
              },
              exit: {
                opacity: 0,
                height: 0
              },
              className: "mt-2",
              children: /*#__PURE__*/_jsx("p", {
                className: "text-sm text-neg-708094- leading-relaxed",
                children: faq.answer
              })
            })]
          }, index))
        })]
      }), /*#__PURE__*/_jsxs(motion.button, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.2
        },
        onClick: () => alert(t.reportProblemComingSoon),
        className: "w-full bg-white rounded-2xl p-5 shadow-md flex items-center justify-center gap-3 text-neg-2D58AD- font-semibold hover-bg---F5F6FA- transition-colors",
        children: [/*#__PURE__*/_jsx(MessageCircle, {
          className: "w-5 h-5"
        }), t.reportProblem]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 safe-area-bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-around max-w-md mx-auto",
        children: [/*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("dashboard"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(Package, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.home
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("packages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(List, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.packages
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("performance"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(TrendingUp, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.performance
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("profile"),
          className: "flex flex-col items-center gap-1 text-neg-2D58AD-",
          children: [/*#__PURE__*/_jsx(User, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.profile
          })]
        })]
      })
    })]
  });
}